import { Controller } from "stimulus"


export default class extends Controller {

    id = 1;
    subTotalAmount = 0;
    taxAmount = 0;
    totalAmount = 0;
    itemStyle
    format
    initialize() {
        if (document.getElementById("get-items")) {
            this.updateItems();
        } else if (document.getElementById("items")) {
            var item = document.getElementById("items").firstChild.nextSibling;
            this.itemStyle = item.innerHTML;
            var items = document.getElementById("items");
            items.firstChild.nextSibling.lastChild.previousSibling.lastChild.previousSibling.classList += " hidden";
        } else {
            this.dateFormat(document.getElementById("date"))
        }
        this.format = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
        });
    }

    addItem() {
        var items = document.getElementById("items");
        var div = document.createElement('div');
        div.classList = "flex flex-wrap w-full relative";
        div.id = `item${this.id}`;
        this.id += 1;
        div.innerHTML = this.itemStyle;
        items.appendChild(div);
        items.lastChild.lastChild.previousSibling.lastChild.previousSibling.classList.remove("hidden");
    }

    delete(event) {
        var id = event.target.parentElement.parentElement.id;
        var items = document.getElementById("items");
        var amount = Number((event.target.previousSibling.previousSibling.lastChild.previousSibling.value).replace(/[$,]/g, "")) || 0;
        var element = document.getElementById(id);
        this.subTotalAmount -= amount;
        this.changeTotal();
        element.parentElement.removeChild(element);
        this.id -= 1;
    }

    changePrice(event) {
        var price = event.target.value || 0;
        var quantity = event.target.parentElement.previousSibling.previousSibling.firstChild.nextSibling.value || 0;
        var previousAmount = Number((event.target.parentElement.nextSibling.nextSibling.lastChild.previousSibling.value).replace(/[$,]/g, "")) || 0;
        var amount = price * quantity;
        this.subTotalAmount -= previousAmount;
        event.target.parentElement.nextSibling.nextSibling.lastChild.previousSibling.value = `${this.format.format(amount)}`;
        this.subTotalAmount += amount;
        this.changeTotal();
    }

    changeQuantity(event) {
        var quantity = event.target.value || 0;
        var price = event.target.parentElement.nextSibling.nextSibling.firstChild.nextSibling.value || 0;
        var previousAmount = Number((event.target.parentElement.nextSibling.nextSibling.nextSibling.nextSibling.lastChild.previousSibling.value).replace(/[$,]/g, "")) || 0;
        var amount = price * quantity;
        this.subTotalAmount -= previousAmount;
        event.target.parentElement.nextSibling.nextSibling.nextSibling.nextSibling.lastChild.previousSibling.value = `${this.format.format(amount)}`;
        this.subTotalAmount += amount;
        this.changeTotal();
    }

    changeTax(event) {
        var value = event.target.value;
        var taxValue = document.getElementById('tax');
        taxValue.innerText = value + "%";
        this.changeTotal();
    }

    editTax() {
        var editButton = document.getElementById('edit');
        var saveButton = document.getElementById('save');
        var taxInput = document.getElementById('tax-input');
        taxInput.classList.toggle('hidden');
        editButton.classList.toggle('hidden');
        saveButton.classList.toggle('hidden');
    }

    changeTotal() {
        var taxPercentage = Number(document.getElementById('tax').innerText.replace("%", ""));
        this.taxAmount = this.subTotalAmount * taxPercentage / 100;
        this.totalAmount = this.subTotalAmount + this.taxAmount;
        document.getElementById("total-amount").value = `${this.format.format(this.totalAmount)}`;
        document.getElementById("sub-total").value = `${this.format.format(this.subTotalAmount)}`;
        document.getElementById("tax-amount").value = `${this.format.format(this.taxAmount)}`;
    }

    dateFormat(target) {
        var input = target.innerText;
        var pattern = /(\d{4})\-(\d{2})\-(\d{2})/;
        target.innerText = input.replace(pattern, '$2/$3/$1');
    }

    updateItems() {
        var item = document.getElementById("item");
        this.itemStyle = item.innerHTML;
        this.id = document.getElementById("items").childElementCount;
        this.subTotalAmount = Number(document.getElementById("sub-total").value.replace(/[$,]/g, ""));
        this.taxAmount = Number(document.getElementById("tax-amount").value.replace(/[$,]/g, ""));
        this.totalAmount = Number(document.getElementById("total-amount").value.replace(/[$,]/g, ""));
        var items = document.getElementById("items");
        items.firstChild.nextSibling.lastChild.previousSibling.lastChild.previousSibling.classList += " hidden";
    }
}